import { render, staticRenderFns } from "./FloatingPromoButton.vue?vue&type=template&id=3ca470f7&scoped=true"
import script from "./FloatingPromoButton.vue?vue&type=script&lang=js"
export * from "./FloatingPromoButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingPromoButton.vue?vue&type=style&index=0&id=3ca470f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca470f7",
  null
  
)

export default component.exports